import { getFilteredInsurersByType } from 'constants/userInsurersPermissions';

export const insures = [
  { value: 'SURA_MOTOS', label: 'SURA_MOTOS' },
  { value: 'SBS_MOTOS', label: 'SBS_MOTOS' },
  { value: 'MAPFRE_MOTOS', label: 'MAPFRE_MOTOS' },
  { value: 'LIBERTY_MOTOS', label: 'HDI' },
  { value: 'SOLIDARIA_MOTOS', label: 'SOLIDARIA' },
];

export const getFilteredInsurers = (userEmail?: string) => {
  return getFilteredInsurersByType(userEmail, insures, 'motos');
};

export const quoteTypeData = [
  { value: 'Auto', label: 'Auto' },
  { value: 'Motos', label: 'Motos' },
];

export const civilStatus = [
  { value: 'soltero', label: 'Soltero/a' },
  { value: 'casado', label: 'Casado/a' },
  { value: 'libre', label: 'Únion Libre' },
  { value: 'viudo', label: 'Viudo/a' },
  { value: 'separado', label: 'Separado/a' },
];

export const documentType = [
  { value: 'cc', label: 'Cédula de Ciudadania' },
  { value: 'ce', label: 'Cédula de Extranjeria' },
  { value: 'nuip', label: 'NUIP' },
  { value: 'ti', label: 'Tarjeta de Identidad' },
];

export const stratum = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
];

export const educationLevel = [{ value: 'postgrado', label: 'Postgrado' }];

export const occupation = [
  { value: 'empleadoAsalariado', label: 'Empleado/Asalariado' },
  { value: 'independienteComerciante', label: 'Independiente/Comerciante/Socio Propietario' },
  { value: 'estudiante', label: 'Estudiante' },
  { value: 'amaDeCasa', label: 'Ama de Casa' },
  { value: 'pensionado', label: 'Pensionado/a' },
  { value: 'rentista', label: 'Rentista/Inversionista' },
];

export const profession = [
  { value: 'economista', label: 'Economista' },
  { value: 'administrador', label: 'Administrador' },
  { value: 'ingeniero', label: 'Ingeniero' },
];

export const services = [
  { value: 'particular', label: 'Particular' },
  { value: 'publico', label: 'Público' },
];

export const useForVehiclePublic = [
  { value: 'taxi', label: 'Taxi' },
  { value: 'transporteEscolar', label: 'Transporte Escolar' },
  { value: 'transporteIntermunicipal', label: 'Transporte Intermunicipal' },
  { value: 'alquilerServicios', label: 'Alquiler Servicios Petroleros/Mineros' },
  { value: 'transporteMercanciaPropia', label: 'Transporte Mercancia Propia' },
  { value: 'transporteMercanciaTerceros', label: 'Transporte Mercancia Terceros' },
];

export const useForVehicleParticular = [
  { value: 'usoPersonal', label: 'Uso Personal/Familiar' },
  { value: 'enseñanza', label: 'Enseñanza' },
  { value: 'ambulancia', label: 'Ambulancia' },
];

export const getDefaultValues = (userEmail?: string): ICarsQuotation => ({
  selectedInsurers: getFilteredInsurers(userEmail),
  quoteType: quoteTypeData[0],
  gender: '',
  firstName: '',
  lastName: '',
  fBorn: '',
  civilState: 'separado',
  documentType: 'cc',
  nDocument: '',
  stratum: '6',
  levelEducation: 'postgrado',
  occupation: 'empleadoAsalariado',
  profession: 'economista',
  tVehicle: '',
  service: 'particular',
  useVehicle: 'usoPersonal',
  cityCirculation: '',
  optionalCity: '',
  checkAccesories: false,
  valueAccesories: '',
  licenseVehicle: '',
  codeFasecolda: '',
  modelo: '',
  brand: '',
  ref1: '',
  ref2: '',
  ref3: '',
  valueInsured: '',
  oneroso: 'si',
  nChildren: 0,
});

export const defaultValues: ICarsQuotation = getDefaultValues();
